import {
  Box,
  Button,
  Container,
  Field,
  Flex,
  Heading,
  Input,
  Link,
  Text,
  Textarea,
  VStack
} from "@chakra-ui/react"
import { useState } from "react"
import Footer from "../components/Footer"

const Contact: React.FC = () => {
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [message, setMessage] = useState("")
  const [submitted, setSubmitted] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitError, setSubmitError] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsSubmitting(true)
    setSubmitError(false)
    try {
      const res = await fetch("https://formspree.io/f/xeoaewbl", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ name, email, message })
      })
      if (res.ok) {
        setSubmitted(true)
      } else {
        setSubmitError(true)
      }
    } catch {
      setSubmitError(true)
    } finally {
      setIsSubmitting(false)
    }
  }

  const labelProps = { fontSize: "sm", fontWeight: "medium" } as const

  return (
    <Box>
      <Container maxW="480px" py={24}>
        <Heading
          as="h1"
          size="5xl"
          color="brand.700"
          mb={4}
          style={{ textWrap: "balance" } as React.CSSProperties}
        >
          Get in touch
        </Heading>
        <Text color="gray.600" mb={12} maxW="55ch">
          Questions about running an analysis on your portfolio, pricing, or
          anything else? We read every message.
        </Text>

        {submitted ? (
          <Box bg="gray.50" p={8} borderRadius="xl" mb={12}>
            <Text color="brand.700" fontWeight="semibold" fontSize="lg">
              Message sent.
            </Text>
            <Text color="gray.600" mt={2}>
              We'll get back to you as soon as possible.
            </Text>
          </Box>
        ) : (
          <form onSubmit={handleSubmit} noValidate>
            <VStack gap={5} align="stretch" mb={12}>
              <Field.Root>
                <Field.Label {...labelProps}>Name</Field.Label>
                <Input
                  name="name"
                  placeholder="Your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </Field.Root>

              <Field.Root>
                <Field.Label {...labelProps}>Email address</Field.Label>
                <Input
                  name="email"
                  type="email"
                  placeholder="you@company.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Field.Root>

              <Field.Root>
                <Field.Label {...labelProps}>Message</Field.Label>
                <Textarea
                  name="message"
                  placeholder="What would you like to discuss?"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required
                  rows={5}
                />
              </Field.Root>

              <Button
                type="submit"
                bg="brand.700"
                color="white"
                _hover={{ bg: "brand.600" }}
                size="lg"
                loading={isSubmitting}
              >
                Send message
              </Button>

              {submitError && (
                <Text color="red.500" fontSize="sm">
                  Something went wrong. Please try again or email us directly at{" "}
                  <Link href="mailto:contact@greenflip.homes" color="brand.600">
                    contact@greenflip.homes
                  </Link>
                  .
                </Text>
              )}
            </VStack>
          </form>
        )}

        <Box borderTop="1px solid" borderColor="gray.200" pt={8}>
          <Flex gap={12} wrap="wrap">
            <Box>
              <Text fontSize="sm" fontWeight="semibold" color="brand.700" mb={1}>
                Office
              </Text>
              <Text color="gray.700" fontSize="sm">
                London &amp; Edinburgh
              </Text>
            </Box>
            <Box>
              <Text fontSize="sm" fontWeight="semibold" color="brand.700" mb={1}>
                Email
              </Text>
              <Link
                href="mailto:contact@greenflip.homes"
                color="brand.600"
                fontSize="sm"
                _hover={{ color: "brand.700" }}
              >
                contact@greenflip.homes
              </Link>
            </Box>
          </Flex>
        </Box>
      </Container>

      <Footer />
    </Box>
  )
}

export default Contact
